/* unplugin-vue-components disabled */import script from "./createItem.vue?vue&type=script&setup=true&name=CreateItem&lang=js"
export * from "./createItem.vue?vue&type=script&setup=true&name=CreateItem&lang=js"

import "./createItem.vue?vue&type=style&index=0&id=e7c85ee2&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7c85ee2"]])

export default __exports__